import { useQuery } from '@tanstack/react-query';
import { useApi } from '../api/service';
import type { HealthResponse } from './types';
import { errorHandler } from '@/lib/utils/error-handler';

export const useHealth = () => {
  const { api } = useApi();
  const health = useQuery<HealthResponse, Error>({
    queryKey: ['/health'],
    queryFn: async () => {
      try {
        const start = new Date();
        const response = await api.get<HealthResponse>('/health');
        return { ...response.data, ping: Number(response.data.result) - start.getTime() };
      } catch (error: any) {
        errorHandler(error);
      }
    },
    refetchInterval: 30000,
    staleTime: 30000,
    retryDelay: 3000,
    refetchOnWindowFocus: false,
  });
  return { health };
};
